/**
 * @generated SignedSource<<ac9d636d8d9008c1a9afc7eb05dd5e9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraLongRunningTaskStatus = "CANCELLED" | "CANCEL_REQUESTED" | "COMPLETE" | "DEAD" | "ENQUEUED" | "FAILED" | "RUNNING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type processResponse_bulkOperationsCommon$data = {
  readonly failedAccessibleIssues: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly issue: {
          readonly issueId: string;
          readonly key: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly progress: AGG$Long | null | undefined;
  readonly status: JiraLongRunningTaskStatus | null | undefined;
  readonly totalIssueCount: number | null | undefined;
  readonly " $fragmentType": "processResponse_bulkOperationsCommon";
};
export type processResponse_bulkOperationsCommon$key = {
  readonly " $data"?: processResponse_bulkOperationsCommon$data;
  readonly " $fragmentSpreads": FragmentRefs<"processResponse_bulkOperationsCommon">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "processResponse_bulkOperationsCommon",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "progress"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueCount"
    },
    {
      "concreteType": "JiraIssueBulkOperationFailureConnection",
      "kind": "LinkedField",
      "name": "failedAccessibleIssues",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueBulkOperationFailureEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueBulkOperationFailure",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "issueId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueBulkOperationProgress"
};

(node as any).hash = "6fd178055d35ff262e914a98799a4f45";

export default node;
